.so-root {
  position: fixed;
  inset: 0;
  z-index: 1200;

  visibility: hidden;
  pointer-events: none;
}

.so-root.open {
  visibility: visible;
  pointer-events: auto;
}

/* ==============================
   Backdrop
   ============================== */

.so-backdrop {
  position: absolute;
  inset: 0;

  background: rgba(17, 24, 39, 0.55);
  backdrop-filter: blur(2px);

  opacity: 0;

  transition: opacity 0.2s ease;
}

.so-root.open .so-backdrop {
  opacity: 1;
}

/* ==============================
   Drawer
   ============================== */

.so-panel {
  position: absolute;
  top: 0;
  right: 0;

  width: min(720px, 94vw);
  height: 100dvh;
  max-height: 100dvh;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  background: #ffffff;

  border-left: 1px solid #e5e7eb;

  box-shadow: -10px 0 35px rgba(0, 0, 0, 0.12);

  transform: translateX(100%);

  transition: transform 0.22s ease;
}

.so-root.open .so-panel {
  transform: translateX(0);
}

/* ==============================
   Header
   ============================== */

.so-header {
  flex-shrink: 0;

  min-height: 64px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 12px;
  padding: 14px 18px;

  background: #ffffff;

  border-bottom: 1px solid #e5e7eb;
}

.so-header h3 {
  margin: 0;

  color: #111827;

  font-size: 17px;
  font-weight: 700;
}

.so-close {
  width: 34px;
  height: 34px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0;
  background-color: #fdc9c9;
  color: #f84e4e;

  border: 0;
  border-radius: 8px;

  font-family: inherit;
  font-size: 18px;

  cursor: pointer;

  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

.so-close:hover {
  background-color: #fb9898;
  color: #ffffff;
}

/* ==============================
   Scrollable Body
   ============================== */

.so-body {
  flex: 1;

  min-width: 0;
  min-height: 0;

  padding: 18px;

  overflow-y: auto;
  overflow-x: hidden;

  overscroll-behavior: contain;

  -webkit-overflow-scrolling: touch;
}

/* ==============================
   Footer
   ============================== */

.so-footer {
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 8px;
  padding: 12px 18px;

  background: #ffffff;

  border-top: 1px solid #e5e7eb;
}
